import { useCacheService } from '@fs/zion-cache-service'
import { cacheService } from './caches'

export default function usePrivatePersonCount(treeId) {
  const url = treeId ? `/service/tree/tree-data/trees/${treeId}/persons/count` : null
  const [{ data, loading }, refetch] = useCacheService(cacheService, url, url)

  return {
    privatePersonCount: data?.count ?? 0,
    isLoadingPrivatePersonCount: loading,
    refetchPrivatePersonCount: refetch,
  }
}
